<app-pickup-popup
  [routes]="routes"
  [countryCode]="data.countryCode"
  [formInput]="data.form"
  (submitFormEvent)="getSubmittedForm($event)"
></app-pickup-popup>
